define(
  ['backbone', 'underscore', '../../libs/translationsUtils/translations'],
  function (Backbone, _, translations) {
    var t = translations.t

    return Backbone.Model.extend({
      numberOfLikes: function () {
        return this.get('allUsers').length
      },
      previewUsers: function () {
        return new Backbone.Collection(
          this.get('allUsers').slice(0, this.get('maxNumberOfAvatars'))
        )
      },
      numberOfLikesLabel: function () {
        var numberOfLikes = this.numberOfLikes()
        var currentUserHasLiked = this.get('currentUserHasLiked')
        var label = this.get('isVoteModal') ? 'vote' : 'like'

        if (!currentUserHasLiked) {
          return t('Forum', 'post.' + label + '.number', {
            numberOfLikes: numberOfLikes
          })
        } else if (numberOfLikes === 1) {
          return t('Forum', 'post.' + label + '.number.only_self', {
            numberOfLikes: numberOfLikes
          })
        } else {
          return t('Forum', 'post.' + label + '.number.including_self', {
            numberOfLikes: numberOfLikes - 1
          })
        }
      },
      toJSON: function () {
        return _.extend(
          {
            numberOfLikes: this.numberOfLikes(),
            numberOfLikesLabel: this.numberOfLikesLabel()
          },
          this.attributes
        )
      }
    })
  }
)
